import { sendFetch, POST_OPTIONS, GET_OPTIONS, sendSellerFetch } from './base.service';
import { getCompany, getUserId } from '../_utils/storage_handler';

const BASE_PATH = '/clients';

export const findClientById = async (client_id) => {
    return await sendFetch(`${BASE_PATH}/id/${client_id}`, GET_OPTIONS);
}

export const findClientsByCompany = async (company) => {
    return await sendFetch(`${BASE_PATH}/all/company/${company}`, GET_OPTIONS);
}

export const findAllClientsNamesByCompany = async (company) => {
    return await sendFetch(`${BASE_PATH}/all-client-names/company/${company}`, GET_OPTIONS);
}

export const findClientsWithPocketBalanceByCompany = async () => {
    return await sendFetch(`${BASE_PATH}/all-with-pocket-balance/company/${getCompany()}`, GET_OPTIONS);
}

export const findClientsBySellerCompany = async (seller, company) => {
    return await sendSellerFetch(`${BASE_PATH}/all/seller/company/${seller}/${company}`, GET_OPTIONS);
}

export const findClientsWithPocketBalanceBySellerCompany = async () => {
    return await sendSellerFetch(`${BASE_PATH}/all-with-pocket-balance/seller/company/${getUserId()}/${getCompany()}`, GET_OPTIONS);
}

export const findClientsWithPaymentsBySellerCompany = async () => {
    return await sendSellerFetch(`${BASE_PATH}/all-with-payments/seller/company/${getUserId()}/${getCompany()}`, GET_OPTIONS);
}

export const findClientsWithDeparturesBySellerCompany = async () => {
    return await sendSellerFetch(`${BASE_PATH}/all-with-departures/seller/company/${getUserId()}/${getCompany()}`, GET_OPTIONS);
}

export const findClientsWithPaymentsBySellerCompanyGroupedDate = async () => {
    return await sendSellerFetch(`${BASE_PATH}/all-with-payments/grouped-date/seller/company/${getUserId()}/${getCompany()}`, GET_OPTIONS);
}

export const findClientsWithDeparturesBySellerCompanyGroupedDate = async () => {
    return await sendSellerFetch(`${BASE_PATH}/all-with-departures/grouped-date/seller/company/${getUserId()}/${getCompany()}`, GET_OPTIONS);
}

export const findClientsWithOrdersListBySellerCompany = async () => {
    return await sendSellerFetch(`${BASE_PATH}/all-with-orders-list/seller/company/${getUserId()}/${getCompany()}`, GET_OPTIONS);
}

export const createClient = async (body) => {
    return await sendFetch(`${BASE_PATH}/create`, POST_OPTIONS, body);
}

export const editClient = async (body, id) => {
    return await sendFetch(`${BASE_PATH}/edit/${id}`, POST_OPTIONS, body);
}

export const downloadPricesBySeller = async (seller) => {
    return await sendFetch(`${BASE_PATH}/download/client-prices/seller/company/${seller}/${getCompany()}`, GET_OPTIONS);
}

export const downloadClientsBySeller = async (seller) => {
    return await sendFetch(`${BASE_PATH}/download/client-seller/seller/company/${seller}/${getCompany()}`, GET_OPTIONS);
}